const onReady = (callback) => {
  console.log('[turbo] loaded...');

  document.addEventListener('turbo:load', () => {
    console.log('[turbo] loaded!');

    callback();
  });
};

export default onReady;
